import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlButtonElement } from "./HtmlButtonElement";
import { AppContext } from "../../../Common/AppContext";
import { HtmlController } from "../HtmlController";
import { HtmlAutoplayItemButtonElement } from "./HtmlAutoplayItemButtonElement";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlAutoplayButtonElement extends HtmlButtonElement {
    private _simpleAutoplayCounts: Array<HtmlAutoplayItemButtonElement>;

    constructor() {
        super();
    }

    create(node: Element): void {
        super.create(node);

        if (AppContext.gameConfiguration.AutoplayMode === "basic") {
            this.createBasicMode();
        } else if (AppContext.gameConfiguration.AutoplayMode === "simple") {
            this.createSimpleMode();
        } else if (AppContext.gameConfiguration.AutoplayMode === "advanced") {
            this.createAdvancedMode();
        } else {
            this.createBasicMode();
        }

        if (this.instance != null) {
            this.instance.parentElement.removeChild(this.instance);
        }
    }

    private createBasicMode(): void {
        this.removeOtherMode("simpleAutoplayButton");
        this.removeOtherMode("advancedAutoplayButton");
    }

    private createSimpleMode(): void {
        this.removeOtherMode("basicAutoplayButton");
        this.removeOtherMode("advancedAutoplayButton");

        this._simpleAutoplayCounts = [];
        let holder: HTMLElement = document.getElementById("autoplaySelectorHolder");
        if (holder != null) {
            if (
                AppContext.gameConfiguration.AutoplayCounts != null &&
                AppContext.gameConfiguration.AutoplayCounts.length > 0
            ) {
                AppContext.gameConfiguration.AutoplayCounts.reverse();
                for (let i: number = 0; i < AppContext.gameConfiguration.AutoplayCounts.length; i++) {
                    let button: HtmlAutoplayItemButtonElement = new HtmlAutoplayItemButtonElement();
                    let text: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                    button.action = "AUTOPLAY";
                    button.registerEvents();
                    text.classList.add("autoplayCnt");
                    if (AppContext.gameConfiguration.AutoplayCounts[i] == -1) {
                        text.innerText = "∞";
                        button.autoplayCount = "∞";
                    } else {
                        text.innerText = AppContext.gameConfiguration.AutoplayCounts[i] + "";
                        button.autoplayCount = AppContext.gameConfiguration.AutoplayCounts[i] + "";
                    }
                    button.instance.dataset["test"] = `AUTOPLAY_WIN_CNT_${i + 1}`;

                    if (button.instance != null) {
                        button.instance.classList.add("autoplayItem");
                        button.instance.appendChild(text);
                        HtmlController.registerActionElement("AUTOPLAY", button);
                        if (holder != null) {
                            holder.appendChild(button.instance);
                        }
                    }
                }
            }
        }

        // <div CssClass="autoplayItem" Class="HtmlAutoplayItemButtonElement" Action="AUTOPLAY" AUTOPLAY_COUNT="10">
        //     <span CssClass="autoplayCnt" Class="HtmlText">10</span>
        // </div>
    }

    private createAdvancedMode(): void {
        this.removeOtherMode("basicAutoplayButton");
        this.removeOtherMode("simpleAutoplayButton");
    }

    private removeOtherMode(cls: string): void {
        var elements: HTMLCollectionOf<Element> = document.getElementsByClassName(cls);
        for (var i: number = 0; i < elements.length; i++) {
            var element: HTMLElement = <HTMLElement>elements[i];
            if (element != null) {
                element.remove();
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlAutoplayButtonElement.ts
 **/